<template>
  <b-modal
    id="modal-success-approval"
    size="sm"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="d-flex flex-column justify-content-center">
      <b-img
        class="mt-[16px] mb-[8px] mx-auto"
        src="https://storage.googleapis.com/komerce/assets/icons/success.svg"
        alt="pengajuan produk diterima"
        width="100"
        height="100"
      />
      <p class="text-center text-black font-semibold mb-0">
        Berhasil Disetujui
      </p>
      <p class="text-center text-black">
        Kamu telah memberikan persetujuan untuk produk yang akan disimpan digudangmu.
      </p>
      <b-button
        variant="primary"
        @click="handleFinish"
      >
        Selesai
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModuleSuccessApproval',
  methods: {
    show() {
      this.$bvModal.show('modal-success-approval')
    },
    handleFinish() {
      this.$bvModal.hide('modal-success-approval')
    },
  },
}
</script>
